import { DEFAULT_EINVOICE_ADDRESS_SCHEME_TYPE } from '../constants/defaultEInvoiceAddressSchemeType'
import { getEInvoiceCountryConfig } from './getEInvoiceCountryConfig'

export const getDefaultAddressSchemeTypeByCountry = (isPublicEntity: boolean, countryId: string | undefined) => {
  const { defaultPublicScheme, defaultPrivateScheme = DEFAULT_EINVOICE_ADDRESS_SCHEME_TYPE } =
    getEInvoiceCountryConfig(countryId) || {}

  return isPublicEntity ? defaultPublicScheme : defaultPrivateScheme
}
